import axios from '@/plugins/axios.js';

export default {
    async loadContacts({ commit, state, rootState }, payload) {
        const response = await axios.get('contacts', {
            params: {
                ...payload,
                account_id: rootState.authUser.account.id,
            },
        });

        const data = response.data.data;
        const meta = response.data.meta;

        if (state.pagination.currentPage == meta.current_page) {
            commit('setContacts', data);

            commit('updatePagination', {
                from: meta.from,
                to: meta.to,
                total: meta.total,
                lastPage: meta.last_page,
            });
        }
    },

    async getContact(store, id) {
        const reponse = await axios.get(`contacts/${id}`);

        return reponse.data.data;
    },

    async createContact(store, payload) {
        const response = await axios.post('contacts', payload);

        return response.data.data;
    },

    async updateContact({ commit }, { id, payload }) {
        const response = await axios.put(`contacts/${id}`, payload);
        const contact = response.data.data;

        commit('updateContact', contact);
        commit('chat/updateConversationContact', contact, { root: true });

        return contact;
    },

    async deleteContact({ commit }, id) {
        await axios.delete(`contacts/${id}`);

        commit('removeContact', id);
    },

    async createContactPhone(store, payload) {
        const response = await axios.post('contact-phones', payload);

        return response.data.data;
    },

    async updateContactPhone({ commit }, { id, payload }) {
        const response = await axios.put(`contact-phones/${id}`, payload);
        const contactPhone = response.data.data;

        commit('updateContactPhone', contactPhone);
        commit('chat/updateConversationContactPhone', contactPhone, { root: true });

        return contactPhone;
    },

    async deleteContactPhone(store, id) {
        await axios.delete(`contact-phones/${id}`);
    },
};
